import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'
import {DatePickerViewControl} from '../view_control'
import './index.less'

const NUM_OF_COLUMNS = 4

export const DatePickerMonthView = () => {
	return (
		<ArkDatePicker.View view="month">
			<ArkDatePicker.Context>
				{ctx => (
					<>
						<DatePickerViewControl />
						<ArkDatePicker.Table columns={NUM_OF_COLUMNS}>
							<ArkDatePicker.TableBody>
								{ctx.getMonthsGrid({columns: NUM_OF_COLUMNS, format: 'short'}).map((months, rowIndex) => (
									<ArkDatePicker.TableRow key={rowIndex}>
										{months.map(month => (
											<ArkDatePicker.TableCell key={month.value} value={month.value} disabled={month.disabled}>
												<ArkDatePicker.TableCellTrigger>{month.label}</ArkDatePicker.TableCellTrigger>
											</ArkDatePicker.TableCell>
										))}
									</ArkDatePicker.TableRow>
								))}
							</ArkDatePicker.TableBody>
						</ArkDatePicker.Table>
					</>
				)}
			</ArkDatePicker.Context>
		</ArkDatePicker.View>
	)
}
